import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConditionalSearch from './ConditionalSearch';
import SearchTable from './SearchTable';
import { getLetianStaff } from '../../actions/ddActions';
import { getUserPreference } from "../../utilities/common";
import { handleDriverDispatch, openDriverDispatch } from '../../reducers/uiSlice';
import { makeStyles } from '@material-ui/core/styles';
import UniDialog from '../Common/UniDialog';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: theme.spacing(5)
    }
}));

function DriverDispatch() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('driverDispatch');
    let userPref = getUserPreference();

    const openModal = useSelector(openDriverDispatch);

    const [searchType, setSearchType] = useState();
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [dispatchNo, setDispatchNo] = useState();

    useEffect(() => {
        if(openModal) {
            setSearchType('driver_dispatch_new');
        }
    }, [openModal])

    function handleSearchType(type) {
        setSearchType(type)
    }
    function handleSearchContent(from, to, dispatch) {
        setDateFrom(from);
        setDateTo(to);
        setDispatchNo(dispatch)
    }

    return (
        <UniDialog
            fullWidth
            maxWidth='lg'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
            title={t('title_driver_dispatch')}
        >
            <div className={classes.root}>
                <ConditionalSearch handleSearchType={handleSearchType} handleSearchContent={handleSearchContent}/>
                <SearchTable type={searchType} dateFrom={dateFrom} dateTo={dateTo} dispatchNo={dispatchNo}/>
            </div>
        </UniDialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleDriverDispatch(false))
    }
}

export default DriverDispatch;